import { api } from "@shared/lib/apiClient";
import type { Facettes, ReponseRecherche, RequeteRecherche } from "@sfs/contracts";

export const rechercheApi = {
  chercher: (r: Partial<RequeteRecherche>) => api.post<ReponseRecherche>("/recherche", r),
  facettes: () => api.get<Facettes>("/recherche/facettes"),
  exporter: (ids: string[]) => api.telecharger("/prospects/export", { ids }, `prospects-${Date.now()}.csv`),
  assigner: (ids: string[], proprietaireId: string | null) => api.post("/prospects/assigner", { ids, proprietaireId })
};
